import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useCallback, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { Outlet, useLocation } from 'react-router-dom';

import AutoSignin from '@/features/auth/components/auto-signin';
import { SIGNIN_REDIRECT_URL_KEY } from '@/features/auth/config/oidc';
import useUserPid from '@/features/auth/hooks/use-user-pid';

const AuthRouteGuard = ({ onLdIdentifyDone }: { onLdIdentifyDone: VoidFunction }) => {
  const { isAuthenticated } = useAuth();
  const { pid } = useUserPid();
  const location = useLocation();
  const ldClient = useLDClient();

  const handleBeforeSignin = useCallback(() => {
    window.sessionStorage.setItem(SIGNIN_REDIRECT_URL_KEY, location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (isAuthenticated && ldClient && pid) {
      ldClient.identify({ key: pid, kind: 'user' }, undefined, onLdIdentifyDone);
    }
  }, [isAuthenticated, ldClient, onLdIdentifyDone, pid]);

  if (!isAuthenticated) return <AutoSignin onBeforeSignin={handleBeforeSignin} />;

  return <Outlet />;
};
AuthRouteGuard.displayName = 'AuthRouteGuard';

export default AuthRouteGuard;
